import { EllipsisHorizontalIcon, TrashIcon } from "@heroicons/react/24/outline";
import {
  CaretSortIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  PlusIcon,
} from "@radix-ui/react-icons";
import { Portal } from "@radix-ui/react-portal";
import {
  ColumnDef,
  Row,
  flexRender,
  getCoreRowModel,
  useReactTable,
} from "@tanstack/react-table";
import clsx from "clsx";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import parse from "parse-duration";
import { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useGetUserSettings } from "src/api/General/settings";
import { useGetProjects } from "src/api/Services/Projects/projects";
import { useGetPhaseTasks } from "src/api/Services/Tasks/tasks";
import {
  CalendarEventData,
  TimesheetEntryData,
  TimesheetRowData,
  useCreateTimesheetEntryOld,
  useCreateTimesheetRow,
  useCreateTimesheetRows,
  useDeleteTimesheetRow,
  useGetCalendarEvents,
  useOldGetTimesheet,
  useUpdateTimesheetEntry,
  useUpdateTimesheetEntryOld,
  useUpdateTimesheetRow,
} from "src/api/timesheets/timesheets";
import { useSnackBar } from "src/components/Reusable/CustomSnackbarProvider";
import { Button } from "src/components/ui/button";
import { Checkbox } from "src/components/ui/checkbox";
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/components/ui/command";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "src/components/ui/dialog";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "src/components/ui/dropdown-menu";
import { Loading } from "src/components/ui/loading";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "src/components/ui/popover";
import { SecondaryCheckbox } from "src/components/ui/secondary-checkbox";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "src/components/ui/select";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "src/components/ui/tabs";
import { TextInput } from "src/components/ui/text-input";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "src/components/ui/tooltip";
dayjs.extend(isBetween);

type Props = {};

export default function TableTimeSheets({}: Props) {
  const { tab } = useParams();
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!tab) {
  //     navigate(`/timesheets/my-timesheet`);
  //   } else {
  //     if (tab !== "my-timesheet" && tab !== "all-timesheets") {
  //       navigate(`/timesheets/my-timesheet`, {
  //         replace: true,
  //       });
  //     }
  //   }
  // }, [tab]);

  return (
    <div className="flex h-full flex-col overflow-y-auto">
      <div className="flex h-12 items-center border-b border-gray-200/70 px-8">
        <div className="flex select-none items-center space-x-2 text-sm">
          Timesheets
        </div>
      </div>
      <div className="flex flex-1 flex-col overflow-y-auto">
        <Tabs
          defaultValue="my-timesheet"
          value={tab}
          className="flex flex-1 flex-col overflow-auto pt-3"
          onValueChange={(value) => {
            navigate(`/timesheets/${value}`);
          }}
        >
          <TabsList className="shrink-0 border-gray-200/70 px-8">
            <TabsTrigger
              className="font-normal text-gray-500"
              value="my-timesheet"
            >
              My Timesheet
            </TabsTrigger>
            {/* <TabsTrigger
              className="font-normal text-gray-500"
              value="all-timesheets"
            >
              All Timesheets
            </TabsTrigger> */}
          </TabsList>
          <div className="flex-1 overflow-auto">
            <TabsContent
              value="my-timesheet"
              className="flex h-full flex-col overflow-auto"
            >
              {/* <MyTimesheet /> */}
              <MyTimesheet2 />
            </TabsContent>
            {/* <TabsContent value="all-timesheets" className="h-full">
              <AllTimesheets />
            </TabsContent> */}
          </div>
        </Tabs>
      </div>
    </div>
  );
}

export function convertMsToNatural(ms: number, showMinimal: boolean = true) {
  const hours = ms / 3600000;
  const minutes = (ms % 3600000) / 60000;
  // if (showMinimal) {
  if (hours >= 1) {
    if (minutes === 0) {
      return `${Math.floor(hours).toFixed(0)}h`;
    } else {
      return `${Math.floor(hours).toFixed(0)}h ${minutes.toFixed(0)}m`;
    }
  } else {
    return `${minutes.toFixed(0)}m`;
  }
  // }
  return hours >= 1
    ? `${hours.toFixed(0)}h ${minutes.toFixed(0)}m`
    : `${minutes.toFixed(0)}m`;
}

export function getDateOfMonday(date: Date) {
  const day = new Date(date);
  const dayOfWeek = date.getDay();
  const diff = dayOfWeek === 0 ? -6 : 1 - dayOfWeek; // If Sunday, go back 6 days, else go to Monday
  day.setDate(date.getDate() + diff);
  day.setHours(0, 0, 0, 0); // Set time to 00:00
  return day;
}

function MyTimesheet2() {
  const [currentWeek, setCurrentWeek] = useState(getDateOfMonday(new Date()));
  const { data: timesheetResponse, isLoading } = useOldGetTimesheet(
    dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")
  );
  console.log(timesheetResponse);
  // console.log(timesheetResponse);

  // console.log(timesheet);
  // const { data: projects } = useGetProjects();
  // const [data, setData] = useState<TimesheetRowData[]>([]);
  // useEffect(() => {
  //   console.log(data);
  // }, [data]);
  const goToPreviousWeek = () => {
    setCurrentWeek((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(newDate.getDate() - 7);
      return newDate;
    });
  };

  const goToNextWeek = () => {
    setCurrentWeek((prev) => {
      const newDate = new Date(prev);
      newDate.setDate(newDate.getDate() + 7);
      return newDate;
    });
  };

  const getDaysOfWeek = (): string[] => {
    const days: string[] = [];
    for (let i = 0; i < 7; i++) {
      const day = new Date(currentWeek);
      // Adjust to start from Monday (1) instead of Sunday (0)
      day.setDate(currentWeek.getDate() - currentWeek.getDay() + i + 1);
      days.push(dayjs(day).format("YYYY-MM-DD"));
    }
    return days;
  };

  const daysOfWeek = useMemo(() => getDaysOfWeek(), [currentWeek]);
  // const columnHelper = createColumnHelper<TimesheetRowData>();
  const columns: ColumnDef<TimesheetRowData>[] = useMemo(
    () => [
      {
        id: "project",
        header: () => (
          <div className="text-sm capitalize tracking-normal text-gray-700">
            Project
          </div>
        ),
        footer: () => <div className="flex justify-start text-sm">Total</div>,
        cell: ({ row }) => (
          <TooltipProvider>
            <Tooltip delayDuration={0}>
              <TooltipTrigger asChild>
                <div className="truncate">{row.original.project?.name}</div>
              </TooltipTrigger>
              <Portal>
                <TooltipContent
                  side="right"
                  sideOffset={22}
                  className="z-[1000] ml-2 p-2 py-1"
                >
                  <p>{row.original.project?.name}</p>
                </TooltipContent>
              </Portal>
            </Tooltip>
          </TooltipProvider>
        ),
      },
      {
        id: "item",
        header: () => (
          <div className="w-40 text-sm capitalize tracking-normal text-gray-700">
            Activity
          </div>
        ),
        footer: () => "",
        cell: ({ row }) => (
          <ActivitySelectionCell
            row={row}
            week={dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")}
          />
        ),
      },
      ...daysOfWeek.map((day, index) => {
        return {
          id: `hours-${index}`,
          header: () => {
            return (
              <div className="flex w-20 cursor-default items-center justify-between tracking-normal">
                <div className="font-medium capitalize text-gray-800">
                  {dayjs(day).format("ddd, MMM D")}
                </div>
                {/* <div className="capitalize text-gray-500 text-xs">
                  {dayjs(day).format("MMM D")}
                </div> */}
              </div>
            );
          },
          footer: () => {
            const sum = table.getRowModel().rows.reduce((acc, row) => {
              return (
                acc +
                row.original.entries
                  .filter((e) => dayjs(e.date).isSame(day, "day"))
                  .reduce((acc, entry) => acc + entry.time, 0)
              );
            }, 0);
            return (
              <div className="flex justify-start font-medium text-gray-900">
                {sum === 0 ? "-" : convertMsToNatural(sum)}
              </div>
            );
          },
          cell: ({ row }: { row: Row<TimesheetRowData> }) => {
            // console.log(sum);
            return <TimeEntryCell row={row} day={day} />;
          },
        };
      }),
      {
        id: "total",
        header: () => (
          <div className="w-16 text-sm capitalize tracking-normal text-gray-700">
            Total
          </div>
        ),
        footer: () => {
          const sum = table.getRowModel().rows.reduce((acc, row) => {
            // console.log(
            //   row.original.entries.reduce((acc, entry) => acc + entry.time, 0)
            // );
            return (
              acc +
              row.original.entries.reduce((acc, entry) => acc + entry.time, 0)
            );
          }, 0);
          return (
            <div className="flex justify-start font-medium text-gray-900">
              {sum === 0 ? "-" : convertMsToNatural(sum)}
            </div>
          );
        },
        cell: ({ row }) => {
          const time = row.original.entries.reduce(
            (acc, entry) => acc + entry.time,
            0
          );
          return (
            <div className="flex items-center justify-between gap-6 px-6 py-3 font-medium text-gray-900">
              <div>{time === 0 ? "-" : convertMsToNatural(time)}</div>
              <Menu row={row} />
            </div>
          );
        },
      },
      // {
      //   id: "actions",
      //   // header: () =>
      //   cell: ({ row }) => <div>

      //   </div>,
      // }
    ],
    [daysOfWeek, currentWeek]
  );

  function Menu({ row }: { row: Row<TimesheetRowData> }) {
    const deleteRowMutation = useDeleteTimesheetRow();
    const [optionsOpen, setOptionsOpen] = useState(false);
    return (
      <DropdownMenu
        open={optionsOpen}
        onOpenChange={(isOpen) => {
          setOptionsOpen(isOpen);
        }}
      >
        <DropdownMenuTrigger className="focus:outline-none">
          <div
            className={clsx(
              "rounded px-1.5 py-0.5 text-gray-400 transition-all hover:bg-gray-100 hover:text-gray-600",
              optionsOpen ? "bg-gray-100 text-gray-600" : "border-transparent"
            )}
          >
            <EllipsisHorizontalIcon className="h-4 w-4" />
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" side="bottom" className="w-40">
          <DropdownMenuGroup>
            <DropdownMenuItem
              className="py-1 focus:bg-red-50 focus:text-red-600"
              onClick={(e) => {
                e.stopPropagation();
                deleteRowMutation.mutate({
                  _id: row.original._id,
                });
              }}
            >
              <TrashIcon className="mr-2.5 h-3.5 w-3.5" />
              <span className="text-sm">Delete</span>
            </DropdownMenuItem>
          </DropdownMenuGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  }

  function ActivitySelectionCell({
    row,
    week,
  }: {
    row: Row<TimesheetRowData>;
    week: string;
  }) {
    const { data: tasks } = useGetPhaseTasks(String(row.original.project?._id));
    const updateTimesheetRow = useUpdateTimesheetRow(
      dayjs(getDateOfMonday(new Date(week))).format("YYYY-MM-DD")
    );

    // const { stages } = useGetJourneyStages(new ObjectID(row.original.project));

    const [open, setOpen] = useState(false);
    return (
      <TooltipProvider>
        <Popover open={open} onOpenChange={setOpen}>
          <Tooltip delayDuration={0}>
            <PopoverTrigger asChild>
              <TooltipTrigger asChild>
                <div
                  tabIndex={0}
                  className={clsx(
                    "max-w-[200px] cursor-pointer truncate py-3 px-6",
                    !!row.original.item ? "text-gray-800" : "text-gray-400"
                  )}
                >
                  {row.original.item?.name ?? "-"}
                </div>
              </TooltipTrigger>
            </PopoverTrigger>
            <TooltipContent side="right" className="z-50 p-2 py-1">
              <p>{row.original.item?.name ?? "Select Activity"}</p>
            </TooltipContent>
          </Tooltip>

          <PopoverContent className="pointer-events-auto p-0" align="start">
            <Command>
              <CommandInput placeholder="Search activities..." />
              <CommandList>
                <CommandEmpty>No activity found.</CommandEmpty>
                <CommandGroup>
                  {tasks?.map((task) => (
                    <CommandItem
                      key={task._id}
                      onSelect={() => {
                        setOpen(false);
                        updateTimesheetRow.mutate({
                          timesheetRowUpdate: {
                            _id: row.original._id,
                            item: {
                              type: "task",
                              _id: task._id,
                              name: task.title,
                            },
                          },
                        });
                      }}
                    >
                      <div className="min-w-0 truncate">{task.title}</div>
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
      </TooltipProvider>
    );
  }

  function TimeEntryCell({
    row,
    day,
  }: {
    row: Row<TimesheetRowData>;
    day: string;
  }) {
    const createTimesheetEntry = useCreateTimesheetEntryOld(
      dayjs(getDateOfMonday(new Date(day))).format("YYYY-MM-DD")
    );
    const sum = row.original.entries
      .filter((e) => dayjs(e.date).isSame(day, "day"))
      .reduce((acc, entry) => acc + entry.time, 0);

    const [isEditing, setIsEditing] = useState(false);
    const addEntry = () => {
      createTimesheetEntry.mutate({
        timesheetEntry: {
          date: day,
          time: 0,
          isBillable: true,
          description: "",
          rowId: row.original._id,
        },
        phaseId: row.original.project._id,
      });
    };

    return (
      <Popover open={isEditing} onOpenChange={setIsEditing}>
        <PopoverTrigger
          className="outline-none focus:outline-none focus-visible:outline-none"
          onClick={() => {
            // if no entries for the day, add a new entry
            if (
              row.original.entries.filter((e) =>
                dayjs(e.date).isSame(day, "day")
              ).length === 0
            ) {
              addEntry();
            }
          }}
        >
          <div
            className={clsx(
              "flex w-32 cursor-pointer py-3 px-6 font-light",
              isEditing && "bg-gray-100",
              sum === 0 ? "text-gray-300" : "text-gray-600"
            )}
          >
            {sum === 0 ? "-" : convertMsToNatural(sum)}
          </div>
        </PopoverTrigger>
        <PopoverContent className="w-fit p-6">
          <div className="space-y-4">
            {row.original.entries
              .filter((e) => dayjs(e.date).isSame(day, "day"))
              .map((entry, index) => (
                <Entry key={index} entry={entry} day={day} />
              ))}

            <div className="pt-2">
              <Button
                variant={"secondary"}
                onClick={() => {
                  addEntry();
                }}
              >
                Add New Entry
              </Button>
            </div>
          </div>
        </PopoverContent>
      </Popover>
    );
  }

  function Entry({ entry, day }: { entry: TimesheetEntryData; day: string }) {
    const [value, setValue] = useState<string>(
      entry.time === 0 ? "" : convertMsToNatural(entry.time)
    );
    const updateTimesheetEntry = useUpdateTimesheetEntryOld(
      dayjs(getDateOfMonday(new Date(day))).format("YYYY-MM-DD")
    );
    useEffect(() => {
      setValue(entry.time === 0 ? "" : convertMsToNatural(entry.time));
    }, [entry.time]);
    const [description, setDescription] = useState(entry.description);
    return (
      <div className="flex items-start space-x-2">
        <div className="space-y-1">
          <div className="text-xs">Time</div>
          <TextInput
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            autoFocus
            placeholder="e.g. 1h 30m"
            className={clsx(
              !parse(value) &&
                value !== "" &&
                "border-red-500 ring-[0.5px] ring-red-500"
            )}
            onBlur={(e) => {
              updateTimesheetEntry.mutate({
                _id: entry._id,
                time: parse(e.target.value) || 0,
              });
            }}
          />
        </div>
        <div className="space-y-1">
          <div className="text-xs">Billable</div>
          <Select
            value={entry.isBillable ? "true" : "false"}
            onValueChange={(value) => {
              updateTimesheetEntry.mutate({
                _id: entry._id,
                isBillable: value === "true",
              });
            }}
          >
            <SelectTrigger className="h-9 w-20">
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="true">Yes</SelectItem>
              <SelectItem value="false">No</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div className="space-y-1">
          <div className="text-xs">Description</div>
          <TextInput
            value={description}
            className="w-72"
            onChange={(e) => setDescription(e.target.value)}
            onBlur={(e) => {
              updateTimesheetEntry.mutate({
                _id: entry._id,
                description: e.target.value,
              });
            }}
          />
        </div>
      </div>
    );
  }

  // const tableData = useMemo(() => {
  //   return timesheetResponse?.exists ? timesheetResponse.timesheet.rows : [];
  // }, [timesheetResponse]);

  const data = useMemo(() => {
    return timesheetResponse?.exists ? timesheetResponse.timesheet.rows : [];
  }, [timesheetResponse]);
  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const [hoveredCell, setHoveredCell] = useState<{
    columnId: string | null;
    rowIndex: number | null;
  }>({
    columnId: null,
    rowIndex: null,
  });

  const { data: projects } = useGetProjects();
  const [addRowOpen, setAddRowOpen] = useState(false);
  const createTimesheetRow = useCreateTimesheetRow(
    dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")
  );
  // const updateTimesheetRow = useUpdateTimesheetRow(
  //   dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")
  // );

  return (
    <>
      <div className="flex h-16 shrink-0 items-center justify-between space-x-2 border-b border-gray-200/70 px-8">
        <div className="flex items-center space-x-2">
          <div className={clsx("flex rounded-md shadow-sm")}>
            <button
              className={clsx(
                "flex h-8 w-7 items-center justify-center rounded-l-md border border-input text-gray-500 transition-all hover:bg-gray-50 hover:text-gray-700"
              )}
              onClick={goToPreviousWeek}
            >
              <ChevronLeftIcon className="h-3 w-3" />
            </button>

            {/* <Popover>
            <PopoverTrigger asChild> */}
            <button className="w-[136px] border-y border-input px-1 text-sm font-medium text-gray-700 hover:bg-gray-50">
              {`${dayjs(daysOfWeek[0]).format("MMM DD")} - ${dayjs(
                daysOfWeek[6]
              ).format("MMM DD")}`}
            </button>
            <button
              className={clsx(
                "flex h-8 w-7 items-center justify-center rounded-r-md border border-input text-gray-500 transition-all hover:bg-gray-50 hover:text-gray-700"
              )}
              onClick={goToNextWeek}
            >
              <ChevronRightIcon className="h-3 w-3" />
            </button>
          </div>
          {!dayjs(getDateOfMonday(new Date())).isSame(
            dayjs(daysOfWeek[0]),
            "week"
          ) && (
            <Button
              variant={"secondary"}
              onClick={() => {
                setCurrentWeek(getDateOfMonday(new Date()));
              }}
            >
              Go to current week
            </Button>
          )}
          <Select
            value={"total"}
            onValueChange={(value) => {
              // setType(value as "total" | "billable" | "non-billable");
            }}
          >
            <SelectTrigger className="w-48 items-center py-0">
              <div className="flex h-full items-center gap-2">
                <div className="inline-flex h-full items-center border-r pr-2">
                  Entries
                </div>
                <div className="flex justify-start">
                  <SelectValue />
                </div>
              </div>
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="total">All</SelectItem>
              <SelectItem value="billable">Billable</SelectItem>
              <SelectItem value="non-billable">Non-Billable</SelectItem>
            </SelectContent>
          </Select>
        </div>
        
        <Button
          disabled={table.getRowModel().rows.length === 0}
          onClick={() => {
            console.log("submit");
          }}
        >
          Submit Timesheet
        </Button>
      </div>
      {!isLoading ? (
        <>
          <div className="overflow-auto">
            <table
              style={{ borderCollapse: "separate", borderSpacing: 0 }}
              className={clsx(
                "w-full overflow-auto",
                isLoading && "pointer-events-none opacity-50"
              )}
            >
              <thead className="overflow-auto">
                {table.getHeaderGroups().map((headerGroup) => (
                  <tr key={headerGroup.id} className="border-b">
                    {headerGroup.headers.map((header, index) => (
                      <th
                        key={header.id}
                        scope="col"
                        className={clsx(
                          "sticky top-0 z-10 h-11 whitespace-nowrap border-b border-r border-gray-200/70 px-6 text-left text-sm font-normal uppercase tracking-wide text-gray-400 first:left-0 first:z-20 first:pl-8",
                          index === 0 &&
                            "sticky w-[240px] min-w-[240px] max-w-[240px]",
                          index === 1 &&
                            "sticky left-[240px] top-0 z-30 w-[160px] max-w-[160px] border-r-gray-200",
                          index === 8 && "border-r-0",
                          index === 9 &&
                            "sticky right-0 w-full border-l border-l-gray-200",
                          hoveredCell.columnId === header.column.id &&
                            index > 1 &&
                            index < 9 &&
                            hoveredCell.rowIndex !== -1
                            ? "border-r-gray-200 bg-gray-100"
                            : index > 1 && index < 9
                            ? "border-r-gray-200 bg-gray-50"
                            : "bg-gray-50"
                        )}
                        onMouseEnter={() =>
                          setHoveredCell({
                            columnId: header.column.id,
                            rowIndex: -1,
                          })
                        }
                        onMouseLeave={() =>
                          setHoveredCell({ columnId: null, rowIndex: null })
                        }
                      >
                        {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                            )}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody className="overflow-auto bg-white">
                <>
                  {table.getRowModel().rows.map((row, rowIndex) => (
                    <tr
                      key={row.id}
                      className="group relative rounded-lg hover:bg-gray-50"
                      // onClick={() => {
                      //   navigate(`/spaces/${row.original._id}/tasks`);
                      // }}
                    >
                      {row.getVisibleCells().map((cell, index) => (
                        <td
                          key={cell.id}
                          className={clsx(
                            "sticky whitespace-nowrap border-r border-b border-gray-100 border-b-gray-200/70 p-0 text-sm text-gray-500 first:left-0 first:z-10 first:pr-6 first:pl-8 first:font-medium first:text-gray-900 hover:cursor-default",
                            index === 0 &&
                              "w-[240px] max-w-[240px] hover:bg-gray-50",
                            index === 1 &&
                              "left-[240px] z-20 w-[160px] max-w-[160px] border-r-gray-200/70",
                            index === 8 && "border-r-0",
                            index === 9 &&
                              "sticky right-0 w-full border-l border-l-gray-200/70",
                            rowIndex === table.getRowModel().rows.length - 1 &&
                              "border-b-gray-200",

                            (hoveredCell.columnId === cell.column.id ||
                              hoveredCell.rowIndex === rowIndex) &&
                              hoveredCell.rowIndex !== -1 &&
                              hoveredCell.columnId !== "total" &&
                              hoveredCell.columnId !== "project"
                              ? "bg-gray-50 hover:bg-gray-50"
                              : "bg-white"
                          )}
                          onMouseEnter={() => {
                            setHoveredCell({
                              columnId: cell.column.id,
                              rowIndex,
                            });
                            // console.log(cell.column.id);
                          }}
                          onMouseLeave={() =>
                            setHoveredCell({ columnId: null, rowIndex: null })
                          }
                        >
                          <div
                            className={clsx(
                              "pointer-events-none absolute inset-0",
                              hoveredCell.columnId === cell.column.id &&
                                hoveredCell.rowIndex === rowIndex &&
                                cell.column.id !== "total" &&
                                cell.column.id !== "project"
                                ? "border border-gray-400 "
                                : "hover:cursor-default"
                            )}
                          />
                          {flexRender(
                            cell.column.columnDef.cell,
                            cell.getContext()
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </>
              </tbody>
              {table.getRowModel().rows.length > 0 && (
                <tfoot className="">
                  {table.getFooterGroups().map((footerGroup) => (
                    <tr key={footerGroup.id}>
                      {footerGroup.headers.map((header, index) => (
                        <th
                          key={header.id}
                          className={clsx(
                            "sticky bottom-0 whitespace-nowrap border-t border-r border-b border-gray-100 border-b-gray-200/70 px-6 py-3 text-sm text-gray-500 first:left-0 first:z-10 first:pr-6 first:pl-8 first:font-medium first:text-gray-900 first:group-hover:bg-gray-50",
                            index === 0 && "w-[240px] max-w-[240px]",
                            index === 1 &&
                              "left-[240px] z-20 w-[160px] max-w-[160px] border-r-gray-200/70",
                            index === 8 && "border-r-0",
                            index === 9 &&
                              "sticky right-0 border-l border-l-gray-200/70 bg-gray-50",
                            hoveredCell.columnId === header.column.id &&
                              hoveredCell.rowIndex !== -1 &&
                              hoveredCell.columnId !== "total"
                              ? "bg-gray-50 hover:bg-gray-100"
                              : "bg-gray-50"
                          )}
                        >
                          {header.isPlaceholder
                            ? null
                            : flexRender(
                                header.column.columnDef.footer,
                                header.getContext()
                              )}
                        </th>
                      ))}
                    </tr>
                  ))}
                </tfoot>
              )}
            </table>
          </div>
          {table.getRowModel().rows.length === 0 ? (
            <div className="flex h-80 items-center justify-center border-b border-gray-200/70">
              <div className="flex flex-col items-center justify-center gap-4">
                <div className="text-gray-800">No timesheet entries</div>
                <div className="flex items-center justify-center gap-2">
                  <Popover open={addRowOpen} onOpenChange={setAddRowOpen}>
                    <PopoverTrigger asChild>
                      <Button variant={"secondary"}>Add Row</Button>
                    </PopoverTrigger>
                    <PopoverContent
                      className="pointer-events-auto p-0"
                      align="start"
                    >
                      <Command>
                        <CommandInput placeholder="Search projects..." />

                        <CommandList>
                          <CommandEmpty>No project found.</CommandEmpty>
                          <CommandGroup>
                            {projects?.map((project) => (
                              <CommandItem
                                key={project._id}
                                onSelect={() => {
                                  createTimesheetRow.mutate({
                                    phaseId: project._id,
                                  });
                                  setAddRowOpen(false);
                                }}
                                className="max-w-full truncate"
                              >
                                {project.name}
                              </CommandItem>
                            ))}
                          </CommandGroup>
                        </CommandList>
                      </Command>
                    </PopoverContent>
                  </Popover>
                  <AddEntriesFromCalendar
                    currentWeek={currentWeek}
                    key={dayjs(currentWeek).format("YYYY-MM-DD")}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="flex h-16 shrink-0 items-center space-x-2 border-b border-gray-100 px-8">
              <Popover open={addRowOpen} onOpenChange={setAddRowOpen}>
                <PopoverTrigger asChild>
                  <Button variant={"secondary"}>Add Row</Button>
                </PopoverTrigger>
                <PopoverContent
                  className="pointer-events-auto p-0"
                  align="start"
                >
                  <Command>
                    <CommandInput placeholder="Search projects..." />

                    <CommandList>
                      <CommandEmpty>No project found.</CommandEmpty>
                      <CommandGroup>
                        {projects?.map((project) => (
                          <CommandItem
                            key={project._id}
                            onSelect={() => {
                              createTimesheetRow.mutate({
                                phaseId: project._id,
                              });
                              setAddRowOpen(false);
                            }}
                            className="max-w-full truncate"
                          >
                            {project.name}
                          </CommandItem>
                        ))}
                      </CommandGroup>
                    </CommandList>
                  </Command>
                </PopoverContent>
              </Popover>
              {/* <Button variant={"secondary"}>Add Tasks</Button> */}
              <AddEntriesFromCalendar
                currentWeek={currentWeek}
                key={dayjs(currentWeek).format("YYYY-MM-DD")}
              />
            </div>
          )}
        </>
      ) : (
        <Loading className="mx-auto mt-[20vh]" />
      )}
    </>
  );
}

type SelectedEvent = {
  _id: string;
  projectId?: string;
  date: string;
  time: number;
  billable: boolean;
  name: string;
};

export function AddEntriesFromCalendar({ currentWeek }: { currentWeek: Date }) {
  const { data: calendarEvents } = useGetCalendarEvents(
    dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")
  );
  const snackbarCtx = useSnackBar();
  // console.log(calendarEvents);
  const [selectedEntries, setSelectedEntries] = useState<SelectedEvent[]>([]);
  // const calendarEvents: CalendarEventData[] = [
  //   {
  //     id: "1",
  //     duration: 1000 * 60 * 60 * 8,
  //     title: "This is some task",
  //     summary: "Project 1",
  //     start: dayjs("2024-09-11T09:00:00").toISOString(),
  //     end: dayjs("2024-09-11T17:00:00").toISOString(),
  //   },
  //   {
  //     id: "4",
  //     duration: 1000 * 60 * 60 * 2,
  //     title: "This task",
  //     summary: "Project 1",
  //     start: dayjs("2024-09-11T15:00:00").toISOString(),
  //     end: dayjs("2024-09-11T17:00:00").toISOString(),
  //   },
  //   {
  //     id: "2",
  //     duration: 1000 * 60 * 60 * 8,
  //     title: "This is another task with a much longer description",
  //     summary: "Project 2",
  //     start: dayjs("2024-09-12T09:00:00").toISOString(),
  //     end: dayjs("2024-09-12T17:00:00").toISOString(),
  //   },
  //   {
  //     id: "3",
  //     duration: 1000 * 60 * 60 * 2,
  //     title: "This is an ok task",
  //     summary: "Project 3",
  //     start: dayjs("2024-09-13T09:00:00").toISOString(),
  //     end: dayjs("2024-09-13T11:00:00").toISOString(),
  //   },
  // ];

  const groupedCalendarEvents: Record<string, CalendarEventData[]> =
    useMemo(() => {
      let gce: Record<string, CalendarEventData[]> = {};
      // iterate through days of the week
      for (let i = 0; i < 7; i++) {
        const day = dayjs(getDateOfMonday(currentWeek)).add(i, "day");
        gce[day.format("YYYY-MM-DD")] = [];
      }
      // iterate through calendar events and add them to the correct day
      calendarEvents?.forEach((event) => {
        const eventDate = dayjs(event.start).format("YYYY-MM-DD");
        if (gce[eventDate]) {
          gce[eventDate].push(event);
        }
      });
      return gce;
    }, [calendarEvents]);

  const groupedSelectedEvents: Record<string, SelectedEvent[]> = useMemo(() => {
    let gse: Record<string, SelectedEvent[]> = {};
    // iterate through days of the week
    for (let i = 0; i < 7; i++) {
      const day = dayjs(getDateOfMonday(currentWeek)).add(i, "day");
      gse[day.format("YYYY-MM-DD")] = [];
    }
    // iterate through calendar events and add them to the correct day
    selectedEntries?.forEach((event) => {
      const eventDate = dayjs(event.date).format("YYYY-MM-DD");
      if (gse[eventDate]) {
        gse[eventDate].push(event);
      }
    });
    return gse;
  }, [selectedEntries]);
  const [multiSelectedIds, setMultiSelectedIds] = useState<string[]>([]);
  const hasEventsThisWeek = useMemo(() => {
    if (!calendarEvents) return false;
    return calendarEvents?.some((event) => {
      const eventStart = dayjs(event.start);
      const weekStart = dayjs(getDateOfMonday(currentWeek));
      const weekEnd = weekStart.add(6, "day");
      return eventStart.isBetween(weekStart, weekEnd, "day", "[]");
    });
  }, [calendarEvents]);

  const [step, setStep] = useState(0);
  const [open, setOpen] = useState(false);
  const [projectOpen, setProjectOpen] = useState(false);
  const { data: projects } = useGetProjects();
  const createTimesheetRows = useCreateTimesheetRows(
    dayjs(getDateOfMonday(currentWeek)).format("YYYY-MM-DD")
  );
  const { data: settings } = useGetUserSettings();
  useEffect(() => {
    if (createTimesheetRows.isSuccess) {
      setOpen(false);
    }
  }, [createTimesheetRows.isSuccess]);
  const navigate = useNavigate();
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant={"secondary"}>Add from Calendar</Button>
      </DialogTrigger>
      <DialogContent
        className={clsx(
          "flex flex-col gap-0 p-0",
          hasEventsThisWeek && "h-[calc(100vh-10rem)] max-w-4xl"
        )}
      >
        {!!settings?.calendarIntegration ? (
          <>
            <div
              className={clsx(
                "relative flex-1 overflow-auto",
                hasEventsThisWeek ? "pb-12" : "pb-8"
              )}
            >
              <DialogHeader className="p-8 pb-3">
                <DialogTitle>Add Calendar Events</DialogTitle>
              </DialogHeader>

              {!calendarEvents && <Loading className="mx-auto my-4" />}
              {step === 0 && (
                <>
                  {!!calendarEvents && (
                    <>
                      {hasEventsThisWeek ? (
                        <div>
                          <div className="px-8 pb-10 pt-4 text-gray-800">
                            Select the calendar events you want to convert to
                            time entries.
                          </div>
                          <div className="space-y-10">
                            {Object.keys(groupedCalendarEvents).map((date) => {
                              return (
                                <InitialDayEvents
                                  date={date}
                                  events={groupedCalendarEvents[date]}
                                  selectedEntries={selectedEntries}
                                  setSelectedEntries={setSelectedEntries}
                                  // calendarEvents={calendarEvents}
                                />
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        <div className="px-8 pt-2 text-gray-800">
                          You have no calendar events for this week.
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
              {step === 1 && (
                <>
                  {!!calendarEvents && (
                    <>
                      {hasEventsThisWeek ? (
                        <div>
                          <div className="px-8 pb-10 pt-4 text-gray-800">
                            Assign projects to the selected calendar events.
                          </div>
                          <div className="space-y-10">
                            {Object.keys(groupedSelectedEvents).map((date) => {
                              return (
                                <DayEvents
                                  date={date}
                                  events={groupedSelectedEvents[date]}
                                  multiSelectedIds={multiSelectedIds}
                                  setMultiSelectedIds={setMultiSelectedIds}
                                  // selectedEntries={selectedEntries}
                                  setSelectedEntries={setSelectedEntries}

                                  // calendarEvents={calendarEvents}
                                />
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        <div className="px-8 pt-2 text-gray-800">
                          You have no calendar events for this week.
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </div>
            {!!multiSelectedIds.length && step === 1 && (
              <div className="flex h-14 w-full items-center space-x-2 border-t border-gray-200 bg-white px-8">
                <div className="w-20 text-sm text-gray-500">
                  {multiSelectedIds.length} selected
                </div>
                <div className="w-40">
                  <Popover open={projectOpen} onOpenChange={setProjectOpen}>
                    <PopoverTrigger asChild>
                      <Button
                        variant="secondary"
                        className="w-full justify-between space-x-2 font-normal"
                      >
                        <div className="flex space-x-1 text-gray-400">
                          Project
                          {/* <span className="top-0 ml-0.5 text-primary-main">*</span> */}
                          {/* {required && (
                        )} */}
                        </div>
                        <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                      </Button>
                    </PopoverTrigger>
                    <PopoverContent
                      className="pointer-events-auto p-0"
                      align="start"
                    >
                      <Command>
                        <CommandInput placeholder="Search projects..." />

                        <CommandList>
                          <CommandEmpty>No project found.</CommandEmpty>
                          <CommandGroup>
                            {projects?.map((project) => (
                              <CommandItem
                                key={project._id}
                                onSelect={() => {
                                  setSelectedEntries((prev) =>
                                    prev.map((entry) => {
                                      if (
                                        multiSelectedIds.includes(entry._id)
                                      ) {
                                        return {
                                          ...entry,
                                          projectId: project._id,
                                        };
                                      }
                                      return entry;
                                    })
                                  );
                                  setMultiSelectedIds([]);
                                  setProjectOpen(false);
                                  // createTimesheetRow.mutate({
                                  //   phaseId: project._id,
                                  // });
                                }}
                                className="max-w-full truncate"
                              >
                                {project.name}
                              </CommandItem>
                            ))}
                          </CommandGroup>
                        </CommandList>
                      </Command>
                    </PopoverContent>
                  </Popover>
                </div>
                <div className="w-40">
                  <Select
                    onValueChange={(value) => {
                      setSelectedEntries((prev) =>
                        prev.map((entry) => {
                          if (multiSelectedIds.includes(entry._id)) {
                            return {
                              ...entry,
                              billable: value === "billable",
                            };
                          }
                          return entry;
                        })
                      );
                      setMultiSelectedIds([]);
                    }}
                  >
                    <SelectTrigger>
                      <div className="text-gray-400">Billable</div>
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="billable">Yes</SelectItem>
                      <SelectItem value="non-billable">No</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
            )}
            {hasEventsThisWeek && (
              <>
                {step === 0 && (
                  <>
                    <div className="flex shrink-0 justify-between border-t border-gray-200 px-8 py-5">
                      <div>
                        <div className="text-sm text-gray-500">
                          {selectedEntries.length}{" "}
                          {selectedEntries.length === 1 ? "event" : "events"}{" "}
                          selected (
                          {convertMsToNatural(
                            selectedEntries.reduce(
                              (acc, entry) => acc + entry.time,
                              0
                            ),
                            true
                          )}
                          )
                        </div>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Button
                          variant={"secondary"}
                          onClick={() => setOpen(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          disabled={selectedEntries.length === 0}
                          onClick={() => setStep(1)}
                        >
                          Next
                        </Button>
                      </div>
                    </div>
                  </>
                )}
                {step === 1 && (
                  <>
                    <div className="flex shrink-0 justify-between border-t border-gray-200 px-8 py-5">
                      <div>
                        {/* <div className="text-sm text-gray-500">
                      {selectedEntries.length}{" "}
                      {selectedEntries.length === 1 ? "event" : "events"}{" "}
                      selected (
                      {convertMsToNatural(
                        selectedEntries.reduce(
                          (acc, entry) => acc + entry.time,
                          0
                        ),
                        true
                      )}
                      )
                    </div> */}
                        <Button
                          variant={"secondary"}
                          onClick={() => setStep(0)}
                        >
                          Back
                        </Button>
                      </div>
                      <div className="flex items-center space-x-2">
                        <Button
                          variant={"secondary"}
                          onClick={() => setOpen(false)}
                        >
                          Cancel
                        </Button>
                        <Button
                          disabled={createTimesheetRows.isLoading}
                          onClick={() => {
                            const entriesWithNoProject = selectedEntries.filter(
                              (entry) => !entry.projectId
                            );
                            if (entriesWithNoProject.length > 0) {
                              snackbarCtx.showSnackbar(
                                "Every calendar event must be assigned a project.",
                                "error"
                              );
                            } else {
                              createTimesheetRows.mutate(
                                selectedEntries.map((selectedEntry) => {
                                  return {
                                    week: dayjs(
                                      getDateOfMonday(currentWeek)
                                    ).format("YYYY-MM-DD"),
                                    phaseId: String(selectedEntry.projectId),
                                    item: {
                                      type: "activity",
                                      // _id: selectedEntry.projectId,
                                      name: selectedEntry.name,
                                    },
                                    entries: [
                                      {
                                        date: dayjs(selectedEntry.date).format(
                                          "YYYY-MM-DD"
                                        ),
                                        time: selectedEntry.time,
                                        isBillable: selectedEntry.billable,
                                        description: "",
                                        // categoryId: selectedEntry.categoryId,
                                      },
                                    ],
                                  };
                                })
                              );
                            }
                          }}
                        >
                          {createTimesheetRows.isLoading
                            ? "Creating..."
                            : "Create Time Entries"}
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </>
            )}
          </>
        ) : (
          <div className="p-6">
            <DialogHeader>
              <DialogTitle>Add Calendar Events</DialogTitle>
            </DialogHeader>
            <div className="pt-4 text-gray-700">
              Your Google Calendar is not connected. Click{" "}
              <span
                className="cursor-pointer text-black hover:underline"
                onClick={() => {
                  navigate("/settings/integrations/google-calendar");
                }}
              >
                here
              </span>{" "}
              to go to the Google Calendar settings.
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

function InitialDayEvents({
  date,
  events,
  selectedEntries,
  setSelectedEntries,
}: // calendarEvents,
{
  date: string;
  events: CalendarEventData[];
  selectedEntries: SelectedEvent[];
  setSelectedEntries: (entries: SelectedEvent[]) => void;
  // calendarEvents: CalendarEventData[];
}) {
  if (!events.length) return null;
  return (
    <div>
      <div className="mx-8 mb-1 flex items-center gap-3 border-b border-gray-200 pb-2 text-sm text-gray-500">
        {/* <div className="w-4" /> */}
        <div className="flex-1 truncate pr-2">
          Event on {dayjs(date).format("ddd, MMM DD")}
        </div>
        {/* <div className="w-28">Date</div> */}
        <div className="w-24">Duration</div>
        {/* <div className="w-24">Selected</div> */}
        <div className="w-12" />
        {/* <div className="w-40">Category</div> */}
      </div>
      <div className="space-y-0.5">
        {events
          // .filter((e) => dayjs(e.start).format("YYYY-MM-DD") === date)
          .map((event) => (
            <InitialEvent
              event={event}
              selectedEntries={selectedEntries}
              setSelectedEntries={setSelectedEntries}
            />
          ))}
      </div>
    </div>
  );
}

function InitialEvent({
  event,
  selectedEntries,
  setSelectedEntries,
}: {
  event: CalendarEventData;
  selectedEntries: SelectedEvent[];
  setSelectedEntries: (entries: SelectedEvent[]) => void;
}) {
  const { data: projects } = useGetProjects();
  const selectedEntry = selectedEntries.find((entry) => entry._id === event.id);
  const project = projects?.find(
    (project) => project._id === selectedEntry?.projectId
  );
  const [projectOpen, setProjectOpen] = useState(false);
  return (
    <div
      key={event.id}
      className={clsx(
        "group mx-6 flex h-9 items-center gap-3 rounded-md px-2 pr-1 text-sm",
        !!selectedEntry ? "bg-primary/10" : ""
      )}
    >
      <div className="flex-1 cursor-default truncate pr-2">{event.title}</div>
      <div className="w-24 cursor-default">
        {convertMsToNatural(event.duration, true)}
      </div>
      {/* <div className="w-24">
        <Checkbox
          className={clsx(!!selectedEntry ? "" : "hover:bg-gray-100")}
          checked={!!selectedEntry}
          onClick={() => {
            const checked = !!selectedEntry;
            if (!checked) {
              setSelectedEntries([
                ...selectedEntries,
                {
                  _id: event.id,
                  projectId: undefined,
                  date: event.start,
                  time: event.duration,
                  billable: true,
                },
              ]);
            } else {
              setSelectedEntries(
                selectedEntries.filter((entry) => entry._id !== event.id)
              );
            }
          }}
        />
      </div> */}
      <div className="flex w-12 justify-end">
        {/* <Switch /> */}
        <Button
          variant={"secondary"}
          size="sm"
          onClick={() => {
            const checked = !!selectedEntry;
            if (!checked) {
              setSelectedEntries([
                ...selectedEntries,
                {
                  _id: event.id,
                  projectId: undefined,
                  date: event.start,
                  time: event.duration,
                  billable: true,
                  name: event.title,
                },
              ]);
            } else {
              setSelectedEntries(
                selectedEntries.filter((entry) => entry._id !== event.id)
              );
            }
          }}
        >
          <PlusIcon
            className={clsx(
              "h-4 w-4 transition-transform",
              !!selectedEntry ? "rotate-45" : ""
            )}
          />
          {/* {!!selectedEntry ? (
          ) : (
            <PlusIcon className="h-4 w-4" />
          )} */}
        </Button>
        {/* <Checkbox
          className={clsx(!!selectedEntry ? "" : "hover:bg-gray-100")}
          checked={!!selectedEntry}
          onClick={() => {
            const checked = !!selectedEntry;
            if (!checked) {
              setSelectedEntries([
                ...selectedEntries,
                {
                  _id: event.id,
                  projectId: undefined,
                  date: event.start,
                  time: event.duration,
                  billable: true,
                },
              ]);
            } else {
              setSelectedEntries(
                selectedEntries.filter((entry) => entry._id !== event.id)
              );
            }
          }}
        /> */}
      </div>
      {/* <div className="w-40">
    {!!selectedEntries.find((entry) => entry._id === event.id) ? (
      <Select
        disabled={
          !selectedEntries.find((entry) => entry._id === event.id)
        }
      >
        <SelectTrigger
          className="disabled:opacity-40"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SelectValue placeholder={"Select a category"} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Project 1</SelectItem>
          <SelectItem value="2">Project 2</SelectItem>
        </SelectContent>
      </Select>
    ) : (
      <div className="h-8 w-full rounded-md border border-dashed" />
    )}
  </div> */}
    </div>
  );
}

function DayEvents({
  date,
  events,
  setSelectedEntries,
  multiSelectedIds,
  setMultiSelectedIds,
}: // calendarEvents,
{
  date: string;
  events: SelectedEvent[];
  // selectedEntries: {
  //   _id: string;
  //   projectId?: string;
  //   date: string;
  //   time: number;
  //   billable: boolean;
  // }[];
  setSelectedEntries: React.Dispatch<React.SetStateAction<SelectedEvent[]>>;
  multiSelectedIds: string[];
  setMultiSelectedIds: (ids: string[]) => void;
  // calendarEvents: CalendarEventData[];
}) {
  if (!events.length) return null;
  return (
    <div>
      <div className="mx-8 mb-1 flex items-center gap-3 border-b border-gray-200 pb-2 text-sm text-gray-500">
        {/* <div className="w-4" /> */}
        <div className="flex-1 truncate pr-2">
          Event on {dayjs(date).format("ddd, MMM DD")}
        </div>
        {/* <div className="w-28">Date</div> */}
        <div className="w-24">Duration</div>
        <div className="w-24">Billable</div>
        <div className="w-40">Project</div>
        {/* <div className="w-40">Category</div> */}
      </div>
      {events
        // .filter((e) => dayjs(e.start).format("YYYY-MM-DD") === date)
        .map((event) => (
          <Event
            event={event}
            // selectedEntries={selectedEntries}
            setSelectedEntries={setSelectedEntries}
            multiSelectedIds={multiSelectedIds}
            setMultiSelectedIds={setMultiSelectedIds}
          />
        ))}
    </div>
  );
}

function Event({
  event,
  // selectedEntries,
  setSelectedEntries,
  multiSelectedIds,
  setMultiSelectedIds,
}: {
  event: SelectedEvent;
  // selectedEntries: {
  //   _id: string;
  //   projectId?: string;
  //   date: string;
  //   time: number;
  //   billable: boolean;
  // }[];
  setSelectedEntries: React.Dispatch<React.SetStateAction<SelectedEvent[]>>;
  multiSelectedIds: string[];
  setMultiSelectedIds: (ids: string[]) => void;
}) {
  const { data: projects } = useGetProjects();
  // const selectedEntry = selectedEntries.find((entry) => entry._id === event.id);
  const project = projects?.find((project) => project._id === event.projectId);
  const [projectOpen, setProjectOpen] = useState(false);
  // if (!selectedEntry) return null;
  return (
    <div
      key={event._id}
      className="group mx-6 flex h-9 items-center gap-3 rounded-md px-2 text-sm"
    >
      <div className="w-4">
        <Checkbox
          className={clsx(
            multiSelectedIds.includes(event._id) ? "" : "hover:bg-gray-100"
          )}
          checked={multiSelectedIds.includes(event._id)}
          onClick={() => {
            const checked = multiSelectedIds.includes(event._id);
            if (!checked) {
              setMultiSelectedIds([...multiSelectedIds, event._id]);
            } else {
              setMultiSelectedIds(
                multiSelectedIds.filter((id) => id !== event._id)
              );
            }
          }}
          // onClick={() => {
          //   const checked = multiSelectedIds.includes(event._id);
          //   if (!checked) {
          //     setSelectedEntries([
          //       ...selectedEntries,
          //       {
          //         _id: event.id,
          //         projectId: undefined,
          //         date: event.start,
          //         time: event.duration,
          //         billable: true,
          //       },
          //     ]);
          //   } else {
          //     setSelectedEntries(
          //       selectedEntries.filter((entry) => entry._id !== event.id)
          //     );
          //   }
          // }}
        />
      </div>
      <div className="flex-1 cursor-default truncate pr-2">{event.name}</div>
      <div className="w-24 cursor-default">
        {convertMsToNatural(event.time, true)}
      </div>
      <div className="w-24 cursor-default">
        <SecondaryCheckbox
          onClick={(e) => {
            e.stopPropagation();
            setSelectedEntries((selectedEntries) =>
              selectedEntries.map((entry) => {
                if (entry._id === event._id) {
                  return {
                    ...entry,
                    billable: !entry.billable,
                  };
                }
                return entry;
              })
            );
          }}
          checked={event.billable}
        />
        {/* ) : (
          <div className="h-4 w-4 rounded border border-dashed border-gray-300/70" />
        )} */}
      </div>
      <div className="w-40">
        {/* {!!selectedEntry ? ( */}
        <Popover open={projectOpen} onOpenChange={setProjectOpen}>
          <PopoverTrigger asChild>
            <Button
              variant="secondary"
              className="w-full justify-between space-x-2 font-normal"
            >
              {/* <UserIcon viewBox="4 0 20 24" className="h-3.5 shrink-0" /> */}
              {/* {!!selectedTasker && (
  <div
    className={clsx(
      "h-1.5 w-1.5 shrink-0 rounded-full bg-gray-300",
      selectedTasker.type === "internal"
        ? "bg-gray-300"
        : "bg-slate-700"
    )}
  />
)} */}
              {event.projectId ? (
                <div className="truncate">
                  {
                    projects?.find((project) => project._id === event.projectId)
                      ?.name
                  }
                </div>
              ) : (
                <div className="flex space-x-1 text-gray-400/80">
                  Project
                  <span className="top-0 ml-0.5 text-primary-main">*</span>
                  {/* {required && (
    )} */}
                </div>
              )}
              <CaretSortIcon className="ml-2 h-4 w-4 shrink-0 opacity-50" />
            </Button>
          </PopoverTrigger>
          <PopoverContent className="pointer-events-auto p-0" align="start">
            <Command>
              <CommandInput placeholder="Search projects..." />

              <CommandList>
                <CommandEmpty>No project found.</CommandEmpty>
                <CommandGroup>
                  {projects?.map((project) => (
                    <CommandItem
                      key={project._id}
                      onSelect={() => {
                        setSelectedEntries((selectedEntries) =>
                          selectedEntries.map((entry) => {
                            if (entry._id === event._id) {
                              return {
                                ...entry,
                                projectId: project._id,
                              };
                            }
                            return entry;
                          })
                        );
                        setProjectOpen(false);
                        // createTimesheetRow.mutate({
                        //   phaseId: project._id,
                        // });
                      }}
                      className="max-w-full truncate"
                    >
                      {project.name}
                    </CommandItem>
                  ))}
                </CommandGroup>
              </CommandList>
            </Command>
          </PopoverContent>
        </Popover>
        {/* ) : (
          <div className="h-8 w-full rounded-md border border-dashed" />
        )} */}
      </div>
      {/* <div className="w-40">
    {!!selectedEntries.find((entry) => entry._id === event.id) ? (
      <Select
        disabled={
          !selectedEntries.find((entry) => entry._id === event.id)
        }
      >
        <SelectTrigger
          className="disabled:opacity-40"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <SelectValue placeholder={"Select a category"} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="1">Project 1</SelectItem>
          <SelectItem value="2">Project 2</SelectItem>
        </SelectContent>
      </Select>
    ) : (
      <div className="h-8 w-full rounded-md border border-dashed" />
    )}
  </div> */}
    </div>
  );
}
{
  /* <div className="mx-6 mb-1 flex items-center gap-3 border-b border-gray-100 pb-3 text-sm text-gray-500">
                  <div className="w-4" />
                  <div className="flex-1 truncate pr-2">Mon, Sep 09</div>
                  <div className="w-24">Duration</div>
                  <div className="w-40">Project</div>
                  <div className="w-40">Category</div>
                </div>
                {calendarEvents.map((event) => (
                  <div
                    key={event.id}
                    className="group mx-4 flex h-10 cursor-pointer items-center gap-3 rounded-md px-2 text-sm"
                    onClick={() => {
                      const checked = !!selectedEntries.find(
                        (entry) => entry._id === event.id
                      );
                      if (!checked) {
                        setSelectedEntries([
                          ...selectedEntries,
                          {
                            _id: event.id,
                            projectId: undefined,
                            date: event.start,
                            time: event.duration,
                          },
                        ]);
                      } else {
                        setSelectedEntries(
                          selectedEntries.filter(
                            (entry) => entry._id !== event.id
                          )
                        );
                      }
                    }}
                  >
                    <div className="w-4">
                      <Checkbox
                        className={clsx(
                          !!selectedEntries.find(
                            (entry) => entry._id === event.id
                          )
                            ? ""
                            : "group-hover:bg-gray-100"
                        )}
                        checked={
                          !!selectedEntries.find(
                            (entry) => entry._id === event.id
                          )
                        }
                      />
                    </div>
                    <div className="flex-1 truncate pr-2">{event.title}</div>
                    <div className="w-24">
                      {convertMsToNatural(event.duration)}
                    </div>
                    <div className="w-40">
                      {!!selectedEntries.find(
                        (entry) => entry._id === event.id
                      ) ? (
                        <Select
                          disabled={
                            !selectedEntries.find(
                              (entry) => entry._id === event.id
                            )
                          }
                          required
                        >
                          <SelectTrigger
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className="disabled:opacity-40"
                          >
                            <SelectValue
                              placeholder={
                                !!selectedEntries.find(
                                  (entry) => entry._id === event.id
                                )
                                  ? "Select a project"
                                  : ""
                              }
                            />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Project 1</SelectItem>
                            <SelectItem value="2">Project 2</SelectItem>
                          </SelectContent>
                        </Select>
                      ) : (
                        <div className="h-8 w-full rounded-md border border-dashed" />
                      )}
                    </div>
                    <div className="w-40">
                      {!!selectedEntries.find(
                        (entry) => entry._id === event.id
                      ) ? (
                        <Select
                          disabled={
                            !selectedEntries.find(
                              (entry) => entry._id === event.id
                            )
                          }
                        >
                          <SelectTrigger
                            className="disabled:opacity-40"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <SelectValue placeholder={"Select a category"} />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Project 1</SelectItem>
                            <SelectItem value="2">Project 2</SelectItem>
                          </SelectContent>
                        </Select>
                      ) : (
                        <div className="h-8 w-full rounded-md border border-dashed" />
                      )}
                    </div>
                  </div>
                ))} */
}
{
  /* <div className="mx-6 mb-1 flex items-center gap-3 border-b border-gray-100 pb-3 pt-10 text-sm text-gray-500">
                  <div className="w-4" />
                  <div className="flex-1 truncate pr-2">Mon, Sep 09</div>
                  <div className="w-24">Duration</div>
                  <div className="w-40">Project</div>
                  <div className="w-40">Category</div>
                </div>
                {calendarEvents.map((event) => (
                  <div
                    key={event.id}
                    className="group mx-4 flex h-10 cursor-pointer items-center gap-3 rounded-md px-2 text-sm"
                    onClick={() => {
                      const checked = !!selectedEntries.find(
                        (entry) => entry._id === event.id
                      );
                      if (!checked) {
                        setSelectedEntries([
                          ...selectedEntries,
                          {
                            _id: event.id,
                            projectId: undefined,
                            date: event.start,
                            time: event.duration,
                          },
                        ]);
                      } else {
                        setSelectedEntries(
                          selectedEntries.filter(
                            (entry) => entry._id !== event.id
                          )
                        );
                      }
                    }}
                  >
                    <div className="w-4">
                      <Checkbox
                        className={clsx(
                          !!selectedEntries.find(
                            (entry) => entry._id === event.id
                          )
                            ? ""
                            : "group-hover:bg-gray-100"
                        )}
                        checked={
                          !!selectedEntries.find(
                            (entry) => entry._id === event.id
                          )
                        }
                      />
                    </div>
                    <div className="flex-1 truncate pr-2">{event.title}</div>
                    <div className="w-24">
                      {convertMsToNatural(event.duration, true)}
                    </div>
                    <div className="w-40">
                      {!!selectedEntries.find(
                        (entry) => entry._id === event.id
                      ) ? (
                        <Select
                          disabled={
                            !selectedEntries.find(
                              (entry) => entry._id === event.id
                            )
                          }
                          required
                        >
                          <SelectTrigger
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                            className="disabled:opacity-40"
                          >
                            <SelectValue
                              placeholder={
                                !!selectedEntries.find(
                                  (entry) => entry._id === event.id
                                )
                                  ? "Select a project"
                                  : ""
                              }
                            />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Project 1</SelectItem>
                            <SelectItem value="2">Project 2</SelectItem>
                          </SelectContent>
                        </Select>
                      ) : (
                        <div className="h-8 w-full rounded-md border border-dashed" />
                      )}
                    </div>
                    <div className="w-40">
                      {!!selectedEntries.find(
                        (entry) => entry._id === event.id
                      ) ? (
                        <Select
                          disabled={
                            !selectedEntries.find(
                              (entry) => entry._id === event.id
                            )
                          }
                        >
                          <SelectTrigger
                            className="disabled:opacity-40"
                            onClick={(e) => {
                              e.stopPropagation();
                            }}
                          >
                            <SelectValue placeholder={"Select a category"} />
                          </SelectTrigger>
                          <SelectContent>
                            <SelectItem value="1">Project 1</SelectItem>
                            <SelectItem value="2">Project 2</SelectItem>
                          </SelectContent>
                        </Select>
                      ) : (
                        <div className="h-8 w-full rounded-md border border-dashed" />
                      )}
                    </div>
                  </div>
                ))} */
}
